import {uniq} from 'lodash'

export const asOptions = (values = []) => {
  values = uniq(values)
  return values.map((v) => {
    return {key: v, text: v, value: v}
  })
}

export const getNameOptions = (services) => {
  return services.map((s) => {
    return {key: s.id, text: s.name, value: s.name}
  })
}